export default __webpack_public_path__ + "static/media/flower-loading-icon.c60453f3.svg";